<mat-toolbar>
  <div class="left">
    <ng-container *ngIf="(departmentWithVisibility$ | async) as data">
      <button mat-flat-button disableRipple (click)="openChangeDepartmentDialog()"
        *ngIf="data.show">
        <span *ngIf="data.department">{{data.department.name}}</span>
        <span *ngIf="!data.department" i18n>Select Department</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </ng-container>
  </div>
  <div class="right">
    <a class="doc-360-btn ripple"
      mat-icon-button
      matTooltip="Knowledge Base"
      matTooltipPosition="below"
      (click)="openDoc360Widget()"
    >
      <mat-icon>school</mat-icon>
    </a>
    <a class="cogwheel-btn ripple"
       mat-icon-button
       [routerLink]="['/configuration/departments']"
       routerLinkActive="active"
       [matTooltip]="'Workflow' + '\u1D3F' + '\u1D40' + ' Config'"
       i18n-matTooltip
       matTooltipPosition="below"
       *ngIf="accessDepartmentsConfiguration$ | async"
    >
      <mat-icon>settings</mat-icon>
    </a>
    <button mat-flat-button disableRipple [matMenuTriggerFor]="menu">
      <ng-container *ngIf="user$ | async as user">
        <ng-container *ngIf="user.name; then nameTmpl; else emailTmpl"></ng-container>
        <ng-template #nameTmpl>
          <span [matTooltip]="user.email" matTooltipPosition="below">{{user.name}}</span>
        </ng-template>
        <ng-template #emailTmpl>
          <span>{{user.email}}</span>
        </ng-template>
        <mat-icon>arrow_drop_down</mat-icon>
      </ng-container>
    </button>
  </div>
</mat-toolbar>

<mat-menu #menu="matMenu" xPosition="before">
  <button mat-menu-item routerLink="/auth/logout">
    <mat-icon>power_settings_new</mat-icon>
    <span>Sign Out</span>
  </button>
</mat-menu>